import SymbolTest from './SymbolTest';
export default SymbolTest;